export enum LegacyUrl {
  devenirSocietaire,
  contact,
  accueil,
  assembleesGenerales,
  outilsSocietaires,
  mobilisation,
  presse,
  rhf,
  suiviVentes,
}

export const legacyUrls = {
  [LegacyUrl.accueil]: legacyUrlTo(),
  [LegacyUrl.assembleesGenerales]: legacyUrlTo("/assemblees-generales/"),
  [LegacyUrl.devenirSocietaire]: legacyUrlTo("/devenir-societaire/"),
  [LegacyUrl.mobilisation]: legacyUrlTo("/mobilisation-cqlp/"),
  [LegacyUrl.outilsSocietaires]: legacyUrlTo("/boite-a-outils/"),
  [LegacyUrl.presse]: legacyUrlTo("/espace-presse/"),
  [LegacyUrl.rhf]: legacyUrlTo("/professionnel-de-la-restauration/"),
  [LegacyUrl.suiviVentes]: legacyUrlTo("/suivi-des-ventes-cqlp/"),
};

export function legacyUrlTo(path = ""): string {
  return `${process.env["NEXT_PUBLIC_CQLP_WEBSITE_URL"]!}${path}`;
}
